// Module
var code = "<div> <div view=\"Heading\" data-html=\"[[ title ]]\" data-level=\"[[ level ]]\"></div> </div> ";
// Exports
export default code;